/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $UserFollowLeagueList = {
    type: 'array',
    contains: {
        type: 'UserFollowLeague',
    },
} as const;
